import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ProfessorService {
    constructor(private http: HttpClient, private apiService: ApiService) { }

    getImagem(hashFoto: string, qualidade: 'baixa' | 'media' | 'icone'): string {
        if (hashFoto) {
            return `${environment.paths.portal}/content/fotos/${hashFoto}`;
        }
        
        return null;
    }
}
